<template>
    <div>
        <ul class="nav nav-tabs nav-tabs-fillup">
            <li v-for="(tab, index) in tabs"
                :key="tab.title"
                @click="selectTab(index)"
                class="nav-item"
                :class='{"active": (index == selectedIndex)}'
            >
                <a href="javascript:void(0)">{{ tab.title }}</a>
            </li>
        </ul>

        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {},
        data () {
            return {
            selectedIndex: 0,
            tabs: []
            }
        },
        created () {
            this.tabs = this.$children
        },
        mounted () {
            this.selectTab(0)
        },
        methods: {
            selectTab (i) {
                this.selectedIndex = i

                this.tabs.forEach((tab, index) => {
                    tab.isActive = (index === i)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// client/components/SimpleTabs/Tabs.vue